const IraqSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111633)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0Z"
        fill="#A2001D"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="black"
      />
      <path
        d="M15.2175 18.6963C15.2065 18.6963 15.1958 18.697 15.1849 18.6971V18.6963H11.3617C11.5555 17.9473 12.2351 17.3919 13.0436 17.3919V14.7832C10.6462 14.7832 8.69576 16.7337 8.69576 19.131V21.2615V21.305H15.1849H15.2175C15.4572 21.305 15.6522 21.5001 15.6522 21.7398V22.6093H6.95654V25.218H18.2609V21.7397C18.2609 20.0616 16.8956 18.6963 15.2175 18.6963Z"
        fill="#496E2D"
      />
      <path d="M21.7395 22.6093V14.7832H19.1309V25.218H23.4787V22.6093H21.7395Z" fill="#496E2D" />
      <path
        d="M30.4346 22.6094V14.7832H27.8259V22.6094H26.9563V20.0007H24.3477V25.2181H32.1737V22.6094H30.4346Z"
        fill="#496E2D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111633">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IraqSvg;
